import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { empresaLst } from 'src/app/models/empresaLst';
import { CreateEditEmpresaComponent } from '../create-edit-empresa/create-edit-empresa.component';
import { EditFechaFinServicioEmpresaComponent } from '../edit-fecha-fin-servicio-empresa/edit-fecha-fin-servicio-empresa.component';
import { AgregarAdministradorEmpresaComponent } from '../agregar-administrador-empresa/agregar-administrador-empresa.component';
import { UserService } from 'src/app/services/user.service';
import { EditarSaldoComponent } from '../editar-saldo/editar-saldo.component';
import { ListadoAdministradoresComponent } from './listado-administradores/listado-administradores.component';

@Component({
  selector: 'app-index-empresa',
  templateUrl: './index-empresa.component.html',
  styleUrls: ['./index-empresa.component.scss'],
})
export class IndexEmpresaComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public empresaSvc: EmpresaService,
    public userSvc: UserService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: empresaLst[] = [];
    this.displayedColumns = [
      'razonSocial',
      'fechaServicioHasta',
      'estado',
      'saldo',
      'contacto',
      'direccion',
      'botones',
    ];

    this.dataSource = new MatTableDataSource<empresaLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getEmpresas(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getEmpresas(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.empresaSvc
      .getEmpresas(page, numReg, this.searchString)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<empresaLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getEmpresas(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getEmpresas(0, 10);
  }

  openDialogCreate(): void {
    let dialogRef = this.dialog.open(CreateEditEmpresaComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getEmpresas(this.pageIndex, this.pageSize);
      }
    });
  }

  edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditEmpresaComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getEmpresas(this.pageIndex, this.pageSize);
      }
    });
  }

  editFechaServicioEmpresa(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(EditFechaFinServicioEmpresaComponent, {
      data: obj.id,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getEmpresas(this.pageIndex, this.pageSize);
      }
    });
  }

  addAdministrador(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(AgregarAdministradorEmpresaComponent, {
      data: obj.id,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        //  this.getEmpresas(this.pageIndex, this.pageSize);
      }
    });
  }

  editarSaldo(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(EditarSaldoComponent, {
      data: obj.id,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getEmpresas(this.pageIndex, this.pageSize);
      }
    });
  }

  listadoAdministradores(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(ListadoAdministradoresComponent, {
      data: obj.id,
    });
  }
}
